@if (!loadingData() || realisations().length) {
    @for (mainGroup of realisationGroups(); track mainGroup.key; let last = $last) {
        <div
            class="hour-control-check user-select-none"
            [class.selection-mode]="selectedRealisations().length"
            [class.last]="last || realisationGroups().length === 1"
            [class.disabled]="!allowEdit()">
            @for (group of mainGroup.groups ?? []; track group.key) {
                <ng-container
                    *ngTemplateOutlet="
                        realisationGroup;
                        context: {
                            group: group,
                            mainGroup: mainGroup,
                        }
                    ">
                </ng-container>
            }
        </div>
    } @empty {
        <div class="hours-empty py-4 text-center">
            <div class="container-xl fs-6 fw-bold text-uppercase">er zijn geen uren voor deze dag</div>
        </div>
    }
} @else {
    <div class="container d-flex justify-content-center align-items-center p-4">
        <i class="fas fa-spinner fa-spin"></i>
        Data laden...
    </div>
}

<ng-template #realisationGroup let-group="group" let-mainGroup="mainGroup">
    <div class="header d-flex curpoint" [class.empty]="(group.rows?.length ?? 0) === 0" (click)="toggleGroup(group)">
        <div class="container-xl">
            <div class="content d-flex flex-wrap align-items-center column-gap-3 py-2">
                <div class="name-wrapper d-flex flex-column order-lg-2">
                    @let showingCollapsedNames = !group.expanded && group.collapsedNames?.length;

                    <div class="name fs-4 fw-bold lh-1 mb-0">
                        {{ group.title }}
                        @if (group.activeCount > 1 && !showingCollapsedNames) {
                            ({{ group.activeCount }})
                        }
                    </div>

                    @if (showingCollapsedNames) {
                        <app-collapsed-names [names]="group.collapsedNames" />
                    }
                </div>

                <div class="prefix d-flex flex-shrink-0 flex-row-reverse flex-lg-row align-items-center order-lg-1">
                    <button class="icon-button fs-5" [class.active]="group.expanded" mat-icon-button color="primary">
                        @if (group.realisations?.length) {
                            <mat-icon fontSet="fas" fontIcon="fa-chevron-down"></mat-icon>
                        } @else {
                            <mat-icon fontSet="fa-solid" fontIcon="fa-dash"></mat-icon>
                        }
                    </button>
                </div>

                <div class="times d-flex order-md-3 mb-3" [class.pe-none]="!allowEdit()">
                    @let showTime = showGroupTimes(mainGroup);
                    @if (showTime) {
                        <div
                            class="time curpoint flex-grow-1 fw-bold lh-1 mt-3"
                            (click)="onEditGroupTimeClick($event, group, 'begindate', -1)">
                            {{ group.mainRealisation?.begindate | date: 'HH:mm' }}
                        </div>
                    }

                    <div class="between d-flex flex-column align-content-center justify-content-center">
                        <div class="top flex-shrink-0 text-center px-2">
                            {{ group.project?.contractor ?? group.planning?.contractor }}
                        </div>

                        <div
                            class="bottom d-flex flex-shrink-0 align-items-center text-center fw-bold curpoint"
                            (click)="
                                $event.stopPropagation();
                                projectsEditRequested.emit(flattenGroupRealisations(mainGroup))
                            "
                            matTooltip="Project voor alle registraties aanpassen">
                            {{ group.project?.afas_project_id ?? group.planning?.worknumber }}
                        </div>
                    </div>

                    @if (showTime) {
                        <div
                            class="time end flex-grow-1 fw-bold lh-1 text-end curpoint mt-3"
                            (click)="onEditGroupTimeClick($event, group, 'enddate', 1)">
                            {{ group.mainRealisation?.enddate | date: 'HH:mm' }}
                        </div>
                    }
                </div>

                @if (
                    groupingType() === 'project_category' &&
                    (group.key === 'staff' || group.key === 'material') &&
                    group.project
                ) {
                    <div
                        class="buttons d-flex flex-row-reverse flex-md-row align-items-center justify-content-between order-md-3 order-lg-4"
                        [class.pe-none]="!allowEdit()">
                        @if (
                            environment.enableDayreport &&
                            (Features.DayreportsSave | hasFeature) &&
                            (Roles.Codalt | hasRole)
                        ) {
                            <button
                                class="planning-button"
                                [routerLink]="`/dagrapport/${group.planning?.id}/formulier`"
                                mat-icon-button
                                color="primary">
                                <mat-icon fontSet="fas" fontIcon="fa-file-lines"></mat-icon>
                            </button>
                        } @else if (Features.ProjectCommentSave | hasFeature) {
                            <button
                                class="planning-button"
                                (click)="$event.stopPropagation(); projectCommentRequested.emit(group.project)"
                                mat-icon-button
                                color="primary">
                                <mat-icon fontSet="fas" fontIcon="fa-file-lines"></mat-icon>
                            </button>
                        }

                        @if (
                            group.key === 'material' ||
                            (group.key === 'staff' &&
                                ([Functionalities.HourCheck, Functionalities.HourCheckRestricted] | hasFunctionality))
                        ) {
                            <button
                                (click)="$event.stopPropagation(); copyPreviousDayRequested.emit(group)"
                                mat-icon-button
                                color="primary"
                                matTooltip="{{
                                    group.key === 'staff' ? 'Personeel overnemen' : 'Materieel overnemen'
                                }}">
                                <mat-icon fontSet="fas" fontIcon="fa-diagram-predecessor"></mat-icon>
                            </button>
                        }

                        @if (Features.ProjectSave | hasFeature) {
                            <button
                                (click)="$event.stopPropagation(); projectOpenRequested.emit(group.project)"
                                mat-icon-button
                                color="primary">
                                <mat-icon fontSet="fas" fontIcon="fa-external-link-alt"></mat-icon>
                            </button>
                        }
                    </div>
                } @else {
                    <div
                        class="buttons d-flex flex-row-reverse flex-md-row align-items-center justify-content-between order-md-3 order-lg-4"
                        [class.pe-none]="!allowEdit()">
                        @if (
                            group.removable &&
                            ([Functionalities.HourTimeEdit, Functionalities.CommonHourCheck] | hasFunctionality)
                        ) {
                            <button
                                (click)="removeGroup(group, $event)"
                                mat-icon-button
                                color="warn"
                                matTooltip="Alles in deze groep verwijderen">
                                <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    </div>

    @if (group.expanded && group.realisations?.length) {
        <div class="list">
            @for (row of group.rows ?? []; track row.realisation.id) {
                <app-realisation-row
                    class="list-item d-flex w-100"
                    id="realisation-{{ row.realisation.id }}"
                    [class.selected]="
                        row.realisation | valueInArray: selectedRealisations() : selectedRealisations().length
                    "
                    [class.highlight]="highlight() === row.realisation.id"
                    [disabled]="!allowEdit()"
                    [row]="row"
                    [selectionMode]="!!selectedRealisations().length"
                    (press)="longPressSelectionMode(row.realisation, $event)"
                    (pressup)="longPressSelectionModeEnd(row.realisation, $event)"
                    (tap)="toggleSelection(row.realisation, $event)"
                    (approveRequested)="approve(row.realisation)"
                    (approveAllRequested)="approveAllInGroup(group, row.realisation)"
                    (restoreRequested)="restore(row.realisation)"
                    (removeRequested)="removeRow(row.realisation)"
                    (timeEdit)="editTime(row.realisation, $event.field, $event.addToCurrentTime)"
                    (projectEdit)="projectEditRequested.emit(row.realisation)"
                    (pauseUpdated)="updatePause($event, row.realisation.user_id)">
                </app-realisation-row>
            }
        </div>
    }
</ng-template>
